
// import Accordion from './Accordion';
import BusRatesTable from './BusRatesTable';
// import CustomCarousel from './CustomCarousel';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
// import FAQSection from './FAQSection';
import FAQItem from './FAQItem';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Tatazestonrentinpune() {



  const cardData =
  {
    keyword: 'Tata Zest On Rent in Pune',
    heading: 'AB Ghule Cabs: Tata Zest On Rent in Pune',
    headingDescription: 'AB Ghule Cabs offers the Tata Zest on rent in Pune, an ideal choice for those seeking a compact, stylish, and comfortable ride. Known for its sleek design, modern features, and smooth performance, the Tata Zest is perfect for both short and long-distance travel. Whether you are traveling for business, leisure, or a family outing, our well-maintained Tata Zest cars ensure a pleasant and stress-free journey.',

    top: 'Top Reasons to Choose AB Ghule Cabs for Tata Zest On Rent in Pune',

   "topPlaces": [
  {
    title: "Comfortable and Spacious Interior",
    description: "The Tata Zest offers a roomy interior with ample legroom, making it a comfortable choice for both short trips around Pune and long-distance travel. The premium upholstery and thoughtful design enhance the comfort level of every ride."
  },
  {
    title: "Fuel Efficiency",
    description: "The Tata Zest is known for its excellent fuel efficiency, which ensures that your travel expenses stay low, whether you're taking a short trip within Pune or going on a road trip to nearby cities."
  },
  {
    title: "Modern Features",
    description: "Equipped with modern amenities such as air conditioning, a touch-screen infotainment system, Bluetooth connectivity, and USB ports, the Tata Zest ensures a pleasant travel experience with all the comforts you need during your journey."
  },
  {
    title: "Affordable and Transparent Pricing",
    description: "AB Ghule Cabs offers competitive pricing for Tata Zest rentals with no hidden charges. We believe in transparent pricing, so you can trust us to provide you with an affordable ride with no surprises at the end."
  },
  {
    title: "Well-Maintained Vehicles",
    description: "All our Tata Zest cars are regularly serviced and maintained to ensure they are in excellent condition. We prioritize safety and comfort, so you can enjoy a smooth and worry-free ride."
  },
  {
    title: "Professional and Experienced Drivers",
    description: "Our drivers are experienced, well-trained, and knowledgeable about the best routes, ensuring that you reach your destination safely and on time. They are also courteous and helpful, providing you with a pleasant experience throughout your journey."
  },
  {
    title: "Perfect for Both Short and Long-Distance Travel",
    description: "Whether you're looking for a quick trip within the city or planning a longer journey, the Tata Zest is perfect for all types of travel. It offers a smooth, stable, and fuel-efficient ride for every distance."
  },
  {
    title: "Stylish and Elegant",
    description: "The Tata Zest has a sleek design that adds a touch of elegance to your ride. Its modern exterior and sophisticated interior make it a great choice for both business and leisure trips."
  },
  {
    title: "Flexible Rental Options",
    description: "AB Ghule Cabs provides flexible rental options for daily, weekly, and long-term rentals. Whether you need the car for a few hours or several days, we have a rental package that suits your needs."
  },
  {
    title: "24/7 Availability",
    description: "AB Ghule Cabs operates around the clock to ensure that you can get a Tata Zest whenever you need it. Whether you have an early morning flight or a late-night ride, we are always available to serve you."
  }
],


services: [
    {
      "name": "Rent Tata Zest Car in Pune",
      description: "Looking to rent a Tata Zest in Pune? AB Ghule Cabs offers affordable and reliable Tata Zest car rental services for both local and outstation trips. Enjoy a comfortable ride with our well-maintained Tata Zest vehicles."
    },
    {
      "name": "Sedan Cab Service in Viman Nagar",
      description: "Need a sedan taxi in Viman Nagar, Pune? AB Ghule Cabs provides prompt and reliable sedan cab services in Viman Nagar, ensuring a comfortable and hassle-free travel experience."
    },
    {
      "name": "Tata Zest Hire in Pune",
      description: "AB Ghule Cabs offers Tata Zest car hire services in Pune for all your travel needs. Whether you’re traveling for business or leisure, our well-maintained Tata Zest cars are available at affordable rates."
    },
    {
      "name": "Tata Zest Hire in Hadapsar",
      description: "Looking for a Tata Zest rental in Hadapsar? Rent a Tata Zest with AB Ghule Cabs for a smooth and comfortable journey. Our fleet of cars is perfect for local or outstation trips, with competitive pricing."
    },
    {
      "name": "Tata Zest Hire in Pimpri Chinchwad",
      description: "AB Ghule Cabs provides Tata Zest hire services in Pimpri Chinchwad. Whether you need a car for a local trip or an outstation journey, our Tata Zest rentals are available with flexible pricing options."
    },
    {
      "name": "Tata Zest Hire in Kharadi Pune",
      description: "Looking for a Tata Zest on rent in Kharadi? AB Ghule Cabs offers affordable Tata Zest rentals in Kharadi for your convenience, whether for a local trip, business travel, or an outstation journey."
    },
    {
      "name": "Sedan Cabs in Kharadi",
      description: "AB Ghule Cabs offers sedan cab services in Kharadi for all your travel needs. Whether you require a sedan for local sightseeing or an outstation journey, our fleet of well-maintained vehicles ensures a comfortable ride."
    },
    {
      "name": "Sedan Cab Hire in Koregaon Park Pune",
      description: "For sedan cab hire in Koregaon Park, AB Ghule Cabs offers affordable and reliable services. Our sedans are ideal for both local travel and outstation trips, ensuring a smooth and enjoyable journey."
    },
    {
      "name": "Sedan Cab Hire in Kalyani Nagar",
      description: "AB Ghule Cabs provides sedan cab hire services in Kalyani Nagar, Pune. Choose from a wide selection of sedans for local travel, airport pick-up and drop-off, or outstation trips."
    },
    {
      "name": "Sedan Taxi Service in Pune Airport",
      description: "Looking for a sedan taxi service at Pune Airport? AB Ghule Cabs offers reliable and comfortable sedan taxis for airport transfers. We ensure timely arrivals and departures with our experienced drivers."
    },
    {
      "name": "Pune to Shirdi Sedan Taxi Service",
      description: "Traveling from Pune to Shirdi? Rent a sedan taxi with AB Ghule Cabs for a comfortable and safe journey. Our professional drivers ensure you reach your destination on time and in comfort."
    },
    {
      "name": "Pune to Nashik Sedan Cab",
      description: "Book a sedan cab for your trip from Pune to Nashik with AB Ghule Cabs. Our reliable and affordable sedan services ensure a smooth ride to Nashik, whether for business or leisure."
    },
    {
      "name": "Pune to Solapur Sedan Cab",
      description: "AB Ghule Cabs offers affordable sedan cabs for your trip from Pune to Solapur. Enjoy a comfortable journey with our well-maintained cars and experienced drivers who know the best routes."
    },
    {
      "name": "Sedan Cab Hire for Corporate Events",
      description: "Need a sedan for a corporate event? AB Ghule Cabs offers sedan cab hire services for corporate events in Pune. Whether it’s a business meeting, conference, or airport transfer, we provide professional and punctual service."
    },
    {
      "name": "Sedan Cab Hire for Outstation",
      description: "Looking to hire a sedan for an outstation trip? AB Ghule Cabs offers reliable and affordable sedan rental services for outstation travel. Whether it's a one-way trip or round trip, we ensure a comfortable and stress-free experience."
    },
    {
      "name": "Sedan Cab Service Near Me",
      description: "Find reliable sedan cab services near you with AB Ghule Cabs. Whether you're looking for a sedan for local travel or an outstation journey, we provide prompt and affordable taxi services near you."
    },
    {
      "name": "Pune to Alibaug Sedan Cab on Rent",
      description: "Planning a trip to Alibaug? Rent a sedan cab with AB Ghule Cabs for a smooth and comfortable ride from Pune to Alibaug. Our professional drivers ensure timely arrivals and departures."
    },
    {
      "name": "Pune Airport Sedan Cab on Rent",
      description: "AB Ghule Cabs offers sedan cab rentals for airport transfers in Pune. Whether you need to be picked up or dropped off, our sedan taxi service provides timely and comfortable travel to and from Pune Airport."
    },
    {
      "name": "Pune to Mahabaleshwar Sedan Taxi",
      description: "Book a sedan taxi for your journey from Pune to Mahabaleshwar with AB Ghule Cabs. Enjoy a comfortable and scenic ride to this popular hill station with our affordable and reliable sedan services."
    },
    {
      "name": "Pune to Tata Cab Hire",
      description: "Looking for a Tata car rental in Pune? AB Ghule Cabs offers affordable and reliable Tata car hire services for local and outstation trips. Enjoy a comfortable and smooth ride in one of our well-maintained Tata vehicles."
    },
    {
      "name": "Tata Zest on Rent in Pune Contact Number",
      description: "Contact AB Ghule Cabs at +91 8624029699 for prompt and efficient Tata Zest On Rent in Pune. We ensure a smooth and enjoyable ride for all our customers."
    }
  ],

  tableData: [
    ["Rent Tata Zest Car in Pune", "- Sedan Cab Service in Viman Nagar"],
    ["Tata Zest Hire in Pune", "- Tata Zest Hire in Hadapsar"],
    ["Tata Zest Hire in Pimpri Chinchwad", "- Tata Zest Hire in Kharadi Pune"],
    ["Sedan Cabs in Kharadi", "- Sedan Cab Hire in Koregaon Park Pune"],
    ["Sedan Cab Hire in Kalyani Nagar", "- Sedan Taxi Service in Pune Airport"],
    ["Pune to Shirdi Sedan Taxi Service", "- Pune to Nashik Sedan Cab"],
    ["Pune to Solapur Sedan Cab", "- Sedan Cab Hire for Corporate Events"],
    ["Sedan Cab Hire for Outstation", "- Sedan Cab Service Near Me"],
    ["Pune to Alibaug Sedan Cab on Rent", "- Pune Airport Sedan Cab on Rent"],
    ["Pune to Mahabaleshwar Sedan Taxi", "- Pune to Tata Cab Hire"]
  ],
  
  whychoose: [
    {
      WhyChooseheading: "Comfort and Style Combined",
      WhyChoosedescription: "The Tata Zest offers a stylish and comfortable ride, perfect for your travel needs in Pune. Its sleek design and spacious interior provide both comfort and style, making it an ideal option for business trips, family travel, and sightseeing."
    },
    {
      WhyChooseheading: "Well-Maintained Fleet",
      WhyChoosedescription: "All our Tata Zest cars are meticulously maintained to ensure they are in perfect condition. Clean, sanitized, and thoroughly inspected, you can count on a smooth and safe ride whenever you choose to rent with us."
    },
    {
      WhyChooseheading: "Experienced and Professional Drivers",
      WhyChoosedescription: "We prioritize your safety and comfort. Our drivers are well-trained, professional, and experienced, ensuring you have a smooth and secure journey across Pune and nearby areas. They are familiar with local routes and traffic conditions for timely arrivals."
    },
    {
      WhyChooseheading: "Affordable Rental Options",
      WhyChoosedescription: "The Tata Zest offers an affordable and economical rental choice without compromising on comfort. Whether you need it for a short trip or a longer journey, we offer flexible rental plans to suit your budget."
    },
    {
      WhyChooseheading: "Ideal for Business and Leisure",
      WhyChoosedescription: "Whether you are going for a business meeting, airport transfer, or a leisurely tour of Pune, the Tata Zest is the perfect car for a comfortable and hassle-free ride. With its spacious seating and modern features, it offers an enjoyable experience."
    },
    {
      WhyChooseheading: "Flexible Rental Packages",
      WhyChoosedescription: "We offer various rental packages based on your needs. Whether you need the car for a few hours, a day, or an extended rental for a road trip, our packages are flexible and customizable to ensure you get the best service."
    },
    {
      WhyChooseheading: "Convenient Booking Process",
      WhyChoosedescription: "Booking a Tata Zest with AB Ghule Cabs is quick and simple. You can book online through our website or mobile app, or by calling our customer service team for assistance. We make sure the booking process is hassle-free and convenient for you."
    },
    {
      WhyChooseheading: "24/7 Availability",
      WhyChoosedescription: "We offer round-the-clock services to meet your travel needs. Whether it's an early morning ride or a late-night trip, our customer support team is available to help you with bookings and inquiries at any time."
    }
  ]
  
  
  

  }

  const faqData = [
    {
      id: 'FAQ1',
      question: 'How can I rent a Tata Zest in Pune?',
      answer: 'You can easily rent a Tata Zest through our website, mobile app, or by calling our customer service team. We ensure a smooth and quick booking process.',
    },
    {
      id: 'FAQ2',
      question: 'What is the seating capacity of the Tata Zest?',
      answer: 'The Tata Zest comfortably accommodates up to 4 passengers, making it perfect for small groups, families, or business trips.',
    },
    {
      id: 'FAQ3',
      question: 'Is the Tata Zest air-conditioned?',
      answer: 'Yes, all our Tata Zest vehicles are fully air-conditioned, ensuring a comfortable journey in all weather conditions.',
    },
    {
      id: 'FAQ4',
      question: 'How much does it cost to rent a Tata Zest?',
      answer: 'The cost depends on the duration and distance of your rental. We offer competitive rates, and there are no hidden charges. You’ll receive a clear quote before booking.',
    },
    {
      id: 'FAQ5',
      question: 'Are the drivers professional and experienced?',
      answer: 'Yes, all our drivers are experienced, well-trained, and background-checked to ensure your safety and comfort during the ride.',
    },
    {
      id: 'FAQ6',
      question: 'Can I rent the Tata Zest for an outstation trip?',
      answer: 'Absolutely! The Tata Zest is perfect for outstation travel. We offer customizable rental packages for long-distance trips and sightseeing.',
    },
    {
      id: 'FAQ7',
      question: 'What are the payment options for renting the Tata Zest?',
      answer: 'We accept various payment options, including cash, credit/debit card, and online payment via our app, making it easy for you to pay for your rental.',
    },
    {
      id: 'FAQ8',
      question: 'Can I modify or cancel my booking?',
      answer: 'Yes, you can modify or cancel your booking through our website or app. For assistance, you can also contact our customer service team.',
    },
    {
      id: 'FAQ9',
      question: 'Are there any extra charges for waiting or detours?',
      answer: 'Additional charges may apply for waiting time or detours. However, we ensure complete transparency, and all extra charges will be communicated to you in advance.',
    },
    {
      id: 'FAQ10',
      question: 'What makes AB Ghule Cabs different from other rental services?',
      answer: 'AB Ghule Cabs stands out with our commitment to excellent customer service, affordable pricing, a fleet of well-maintained cars like the Tata Zest, professional drivers, and a hassle-free booking process. We provide a personalized, safe, and reliable travel experience.',
    },
  ];
  
  const testimonials = [
    {
      id: 1,
      name: 'Mr. Anil Sharma',
      feedback: 'I rented the Tata Zest for a day trip to explore Pune, and I must say it was a fantastic experience. The car was very comfortable, and the driver was polite and knew the best routes. I will definitely rent from AB Ghule Cabs again.',
      rating: 5,
    },
    {
      id: 2,
      name: 'Ms. Sita Rao',
      feedback: 'We rented the Tata Zest for a family outing, and it was a great choice. The car was clean, spacious, and air-conditioned. The driver was courteous, and we had a smooth ride throughout. Highly recommend AB Ghule Cabs for their excellent service!',
      rating: 5,
    },
  ];
  
  






  const carouselItems = testimonials.map(testimonial => (
    <div key={testimonial.name}>
      <blockquote>

        <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
        <footer className=' user'>— {testimonial.name}</footer>
      </blockquote>
    </div>
  ));

  const carouselOptions = {
    loop: true,
    margin: 10,
    nav: true,
    items: 1
  };

  const contactData = {
    heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 8624029699",
      

    ],
    email: "booking@abghulecabs.com"
  };


  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "Mumbai Cab Service",
    },
    {
      place: "/images/keyword/2.jpg",
      text: "Mumbai to Shirdi Cab",
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Mumbai Darshan Cabs",
    },
    {
      place: "/images/keyword/4.jpg",
      text: "Mumbai to Vadodara Taxi",
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Mumbai to Pune Cab",
    },
    {
      place: "/images/keyword/6.jpg",
      text: " Mumbai to Goa Taxi",
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Mumbai Airport Cab",
    },

    {
      place: "/images/keyword/8.jpg",
      text: "Mumbai Surat Cabs",
    },

    {
      place: "/images/keyword/9.jpg",
      text: "Mumbai to Mahabaleshwar Cab",
    },
    {
      place: "/images/keyword/10.jpg",
      text: "Mumbai to Konkan Cab",
    },

    {
      place: "/images/keyword/11.jpg",
      text: "Pune Cab Service",
    },
    {
      place: "/images/keyword/12.jpg",
      text: "Pune Taxi Hire",
    },

    {
      place: "/images/keyword/13.jpg",
      text: "Pune Online Cab Booking",
    },

    {
      place: "/images/keyword/14.jpg",
      text: "Best Cab Service in Pune",
    },
    {
      place: "/images/keyword/15.jpg",
      text: "Pune to Mumbai Cabs",
    },
    {
      place: "/images/keyword/16.jpg",
      text: "Pune to Nashik Cabs",
    },
    {
      place: "/images/keyword/17.jpg",
      text: "Pune to Mahabaleshwar Cabs",
    },
    {
      place: "/images/keyword/18.jpg",
      text: "Pune to Lonavala Cabs",
    },
    {
      place: "/images/keyword/19.jpg",
      text: "Pune to Shirdi Cab",
    },
    {
      place: "/images/keyword/20.jpg",
      text: "Pune to Lavasa city cabs",
    },
    {
      place: "/images/keyword/21.jpg",
      text: "Pune to Bhimashankar Cab",
    },
    {
      place: "/images/keyword/22.jpg",
      text: "Pune to Indore Cabs",
    },
    {
      place: "/images/keyword/23.jpg",
      text: "Pune to Konkan Darshan Cabs",
    },
    {
      place: "/images/keyword/24.jpg",
      text: "Pune Outstation Cabs",
    },
    {
      place: "/images/keyword/25.jpg",
      text: "Pune to Panchgani Cab Fare",
    },
    {
      place: "/images/keyword/26.jpg",
      text: "Pune to Mumbai International Airport Cab",
    },
    {
      place: "/images/keyword/27.jpg",
      text: "Ashtavinayak Darshan Cab",
    },
  ];


  const images = [
    { src: "/images/our-fleet/1.jpg", alt: "Image 1" },
    { src: "/images/our-fleet/2.jpg", alt: "Image 2" },
    { src: "/images/our-fleet/3.jpg", alt: "Image 3" },
    { src: "/images/our-fleet/4.jpg", alt: "Image 4" },
    { src: "/images/our-fleet/5.jpg", alt: "Image 5" },
    { src: "/images/our-fleet/6.jpg", alt: "Image 6" },
    { src: "/images/our-fleet/7.jpg", alt: "Image 7" },
    { src: "/images/our-fleet/8.jpg", alt: "Image 8" },
    { src: "/images/our-fleet/9.jpg", alt: "Image 9" },
  ];





  return (
    <div>
      <Helmet>
  <title>Contact: +91 8624029699 | AB Ghule Cabs | Tata Zest on Rent in Pune | Sedan Car Hire & Rental</title>
  <meta name="description" content="Tata Zest on rent in Pune. Offering sedan cars for local and outstation trips. Book online or call +91 8624029699 for Pune to Shirdi, Nashik, Mahabaleshwar, and more." />
  <meta name="keywords" content="Rent Tata Zest Car in Pune, sedan cab service in Viman Nagar, tata zest hire in Pune, tata zest hire in Hadapsar, tata zest hire in Pimpri Chinchwad, tata zest hire in Kharadi Pune, sedan cabs in Kharadi, sedan cab hire in Koregaon Park Pune, sedan cab hire in Kalyani Nagar, sedan taxi service in Pune airport, pune to shirdi sedan taxi service, pune to nashik sedan cab, pune to solapur sedan cab, sedan cab hire for corporate events, Sedan Cab Hire for Outstation, sedan cab service near me, pune to alibaug Sedan Cab on Rent, pune airport sedan cab on rent, pune to mahabaleshwar Sedan Taxi, Pune to tata Cab Hire" />
  <meta name="robots" content="index, follow" />
  <meta property="og:title" content="Contact: +91 8624029699 | AB Ghule Cabs | Tata Zest on Rent in Pune | Sedan Car Hire & Rental" />
  <meta property="og:description" content="Tata Zest on rent in Pune. Offering sedan cars for local and outstation trips. Book online or call +91 8624029699 for Pune to Shirdi, Nashik, Mahabaleshwar, and more." />
  <meta property="og:image" content="https://abghulecabs.com/images/tata-zest-rent.jpg" />
  <meta property="og:url" content="https://abghulecabs.com/tata-zest-on-rent-in-pune" />
  <meta property="og:type" content="website" />
  <meta property="og:site_name" content="AB Ghule Cabs" />

  <script type="application/ld+json">
    {`
      {
        "@context": "https://schema.org",
        "@type": "LocalBusiness",
        "name": "AB Ghule Cabs - Tata Zest on Rent in Pune",
        description: "Tata Zest on rent in Pune. Offering sedan cars for local and outstation trips. Book online or call +91 8624029699 for Pune to Shirdi, Nashik, Mahabaleshwar, and more.",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "Pune, Maharashtra",
          "addressLocality": "Pune",
          "addressRegion": "Maharashtra",
          "postalCode": "411001",
          "addressCountry": "IN"
        },
        "telephone": "+91-8624029699",
        "url": "https://abghulecabs.com/tata-zest-on-rent-in-pune",
        "logo": "https://abghulecabs.com/images/tata-zest-rent.jpg",
        "image": "https://abghulecabs.com/images/tata-zest-rent.jpg",
        "priceRange": "₹1500 - ₹3500",
        "offers": {
          "@type": "Offer",
          "url": "https://abghulecabs.com/tata-zest-on-rent-in-pune",
          "priceCurrency": "INR",
          "price": "1500",
          "priceValidUntil": "2024-12-31"
        },
        "aggregateRating": {
          "@type": "AggregateRating",
          "ratingValue": "4.6",
          "reviewCount": "110"
        },
        "review": [
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Anil K"
            },
            "datePublished": "2024-11-22",
            "reviewBody": "Booked a Tata Zest for a trip to Mahabaleshwar. Great service, the car was clean and well-maintained. Highly recommend AB Ghule Cabs!"
          },
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Sushmita G"
            },
            "datePublished": "2024-10-30",
            "reviewBody": "Tata Zest was perfect for our trip to Nashik. The service was top-notch and the ride was comfortable. Thanks to AB Ghule Cabs!"
          }
        ],
        "serviceArea": {
          "@type": "Place",
          "name": "Pune Tata Zest Rentals",
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": "18.5204",
            "longitude": "73.8567"
          }
        },
        "availableChannel": {
          "@type": "ServiceChannel",
          "serviceUrl": "https://abghulecabs.com/tata-zest-on-rent-in-pune"
        },
        "keywords": "Rent Tata Zest Car in Pune, sedan cab service in Viman Nagar, tata zest hire in Pune, tata zest hire in Hadapsar, tata zest hire in Pimpri Chinchwad, tata zest hire in Kharadi Pune, sedan cabs in Kharadi, sedan cab hire in Koregaon Park Pune, sedan cab hire in Kalyani Nagar, sedan taxi service in Pune airport, pune to shirdi sedan taxi service, pune to nashik sedan cab, pune to solapur sedan cab, sedan cab hire for corporate events, Sedan Cab Hire for Outstation, sedan cab service near me, pune to alibaug Sedan Cab on Rent, pune airport sedan cab on rent, pune to mahabaleshwar Sedan Taxi, Pune to tata Cab Hire"
      }
    `}
  </script>
</Helmet>

      <section id="about" className="jarallax text-light">
        <div className="center-y relative text-center">
          <div className="container">
            <div className="row">
              <div className="col-md-12 text-center">
                <h1 className='text-white'>{cardData.keyword}</h1>
              </div>
              <div className="clearfix"></div>
            </div>
          </div>
        </div>
      </section>

      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 ">
              <img src='/images/keyword/44.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#FF4101', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px',
                        transition: 'transform 0.2s'
                      }}

                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>

              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>


              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Ab Ghule Cabs</h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        {faqData.map((faq) => (
                          <FAQItem key={faq.id} id={faq.id} question={faq.question} answer={faq.answer} />
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>


              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <div>

                <div className="contact-box Borderr">
                  <h3>{contactData.heading}</h3>
                  <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                  <div className="contact-details">
                    <p><strong className='darkcolor'>Mobile No:</strong></p>
                    <ul>
                      {contactData.contactNumbers.map((number, index) => (
                        <li key={index}>
                          <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                            {number}
                          </a>
                        </li>
                      ))}
                    </ul>
                    <p><strong className='darkcolor'>Email Id: </strong>
                      <a href={`mailto:${contactData.email}`} className="contact-link">
                        {contactData.email}
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className='col-12 col-md-4' >
              {Images.map((e) => {
                return (
                  <div className="box1">
                    <a
                      href="./"
                      className="d-flex justify-content-around align-items-center"
                    >
                      <div className="b1">
                        <img src={e.place} alt="img" />
                      </div>
                      <div className="b2">
                        {" "}
                        <a href="./" className='px-3'>{e.text}</a>
                      </div>
                    </a>
                  </div>
                );
              })}


              <div className="gallery-container">
                <h2 className="gallery-title">Our Fleets</h2>
                <div className="gallery-row d-flex flex-wrap">
                  {images.map((image, index) => (
                    <div className="gallery-item col-md-4" key={index}>
                      <img
                        src={image.src}
                        alt={image.alt}
                        className="gallery-image"

                      />
                    </div>
                  ))}
                  {/* <Link to='/gallery' className=' border radius-5 bg-redd p-3 text-white rounded-5 '>
                    See Gallery
                  </Link> */}
                </div>
              </div>

              <div className=" rounded p-4 shadow-sm Uni_border "
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px dotted #FF4101',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#FF4101' }}>
                      <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                      <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                      <div className=''>
                        <a href="tel:+91 8624029699" className="d-block  text-white">+91 8624029699</a>
                        

                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">
                      <i className="bi bi-envelope fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#FF4101' }}>
                        <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                        <a href="mailto:booking@abghulecabs.com" className=" text-white d-block">
                          booking@abghulecabs.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border  rounded text-center">
                      <i className="bi bi-house-fill fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#FF4101' }}>
                        <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                        <p className="whit text-white ">
                          <i> AB Ghule Cabs<br />
                            R -10 Office No -1606,   <br />
                            Life Republic Mulshi, Marunji  <br />
                            Pune, Maharashtra - 411057.

                          </i>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>



            </div>
          </div>
        </div>
      </section>






    </div>
  );
}

export default Tatazestonrentinpune;